import React from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="111"
    height="119"
    viewBox="0 0 111 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d)">
      <g clipPath="url(#clip0)">
        <path
          d="M64.4362 77.4056C68.1181 77.4056 71.1029 74.4208 71.1029 70.7389C71.1029 67.057 68.1181 64.0723 64.4362 64.0723C60.7543 64.0723 57.7695 67.057 57.7695 70.7389C57.7695 74.4208 60.7543 77.4056 64.4362 77.4056Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57.7695 70.7383H71.1029"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.4362 64.0723C66.1037 65.8978 67.0514 68.267 67.1029 70.7389C67.0514 73.2109 66.1037 75.58 64.4362 77.4056C62.7687 75.58 61.821 73.2109 61.7695 70.7389C61.821 68.267 62.7687 65.8978 64.4362 64.0723V64.0723Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path d="M53.436 81.7383L73.436 81.7383" strokeWidth="2" strokeLinecap="round" />
      <path
        d="M67.5534 28.2991L66.6723 25.0109C66.1005 22.8771 63.9072 21.6107 61.7733 22.1825L30.8637 30.4647C28.7298 31.0365 27.4635 33.2298 28.0353 35.3637L39.941 79.7963"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65 46.5C67.7614 46.5 70 44.2614 70 41.5C70 38.7386 67.7614 36.5 65 36.5C62.2386 36.5 60 38.7386 60 41.5C60 44.2614 62.2386 46.5 65 46.5Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57 52.9969C56.9987 52.6075 57.078 52.2228 57.232 51.8719C57.7154 50.8107 59.0785 50.2482 60.2096 49.9935C61.0254 49.8024 61.8524 49.6747 62.6845 49.6114C64.2251 49.4629 65.7746 49.4629 67.3152 49.6114C68.1473 49.6754 68.9742 49.8031 69.7901 49.9935C70.9212 50.2482 72.2843 50.7576 72.7677 51.8719C73.0774 52.5871 73.0774 53.4173 72.7677 54.1325C72.2843 55.2468 70.9212 55.7562 69.7901 56.0003C68.9753 56.1993 68.148 56.3306 67.3152 56.393C66.0613 56.5097 64.8015 56.531 63.5449 56.4567C63.3493 56.4567 63.1581 56.4567 62.9653 56.4371C62.7769 56.418 62.5896 56.3869 62.401 56.3692C61.6671 56.3006 60.9382 56.1773 60.2193 56.0003C59.0785 55.7562 57.7251 55.2468 57.232 54.1325C57.0788 53.7776 56.9995 53.3897 57 52.9969Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="43.436"
        y="31.7383"
        width="40"
        height="55"
        rx="4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="-5"
        y="-1.5"
        width="124"
        height="124"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="13" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(56.436 62.7383)" />
      </clipPath>
    </defs>
  </svg>
);
